import React from "react";
import { withTranslation } from "react-i18next";
import { Button, ButtonGroup, Col, Container, Row, ToggleButton } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import PaginationTable from "../../../../components/paginationTable/PaginationTable";
import { faFilter, faPlus } from "@fortawesome/free-solid-svg-icons";
import { textFilter } from "react-bootstrap-table2-filter";
import APIErrorHelper from "../../../../helpers/APIErrorHelper";
import { Link } from "react-router-dom";
import StorageService from "../../../../services/StorageService";

class ExamsTab extends React.Component {
  tableId = "examsTabTable";

  constructor(props) {
    super(props);
    let showFilters = StorageService.getTableConfigValue(this.tableId, "showFilters");
    this.state = {
      apiError: "",
      exams: [],
      displayFilter: showFilters ? "initial" : "none",
      showFilters,
      closeAction: () => {
      }
    };

    this.fetchData = this.fetchData.bind(this);
  }

  async fetchData() {
    try {
      let exams = await CamplaCoreService.getAllExaminations();
      exams = exams.filter(
        e => e.instanceTemplateId === this.props.instanceTemplate._id
      );
      this.setState({
        exams
      });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        )
      });
    }
  }

  loadCachedData() {
    const cachedExams = StorageService.getReferenceType("instanceTemplateExams");
    if (cachedExams) {
      this.setState({
        exams: cachedExams
      });
    }
  }

  async componentDidMount() {
    this.loadCachedData();
    await this.fetchData();
  }

  render() {
    const { t } = this.props;
    const columns = [
      {
        dataField: "name",
        text: t("SingleInstanceTemplate.ExamsTab.ColumnName"),
        sort: true,
        filter: textFilter({
          style: { display: this.state.displayFilter },
          placeholder: t(
            "SingleInstanceTemplate.ExamsTab.FilterNamePlaceholder"
          )
        }),
        formatter: (name, examination) => (
          <Link
            className="item-link"
            to={{
              pathname: `/examinations/${examination._id}`,
              state: {
                examination
              }
            }}
          >
            {name}
          </Link>
        )
      },
      {
        dataField: "instancesCount",
        text: t("SingleInstanceTemplate.ExamsTab.ColumnInstancesCount"),
        sort: true
      },
      {
        dataField: "actions",
        text: "",
        headerFormatter: () => (
          <ButtonGroup
            toggle
            style={{ float: "right", marginRight: "-12px" }}
          >
            <ToggleButton
              type="checkbox"
              value={1}
              className="btn-green btn-sm"
              checked={this.state.showFilters}
              onChange={e => {
                this.setState({
                  showFilters: e.currentTarget.checked,
                  displayFilter: e.currentTarget.checked ? "initial" : "none"
                });
                StorageService.setTableConfigValue(this.tableId, "showFilters", e.currentTarget.checked);
              }}
            >
              <FontAwesomeIcon icon={faFilter} />
            </ToggleButton>
          </ButtonGroup>
        ),
        headerClasses: "actionHeader",
        isDummyField: true,
        csvExport: false,
        formatter: () => (<div />)
      }
    ];

    return (
      <div>
        <Container className="pl-0 pr-0">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row className="mt-3">
            <Col>
              <h4>{t("SingleInstanceTemplate.ExamsTab.Title")}</h4>
            </Col>
            <Col>
              <Button
                className="btn-green"
                style={{ float: "right" }}
                onClick={() => this.setState({ showCreateModal: true })}
              >
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <PaginationTable
                data={this.state.exams}
                sizePerPage={10}
                paginationSize={3}
                columns={columns}
                keyField="_id"
                ref={this.paginationTableRef}
                id={this.tableId}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default withTranslation()(ExamsTab);
